// extracted by mini-css-extract-plugin
module.exports = {"section":"adminPage_section__35vpD"};